import type { BookingRetryWheelPickupApiData, BookingRetryWheelPickupApiResponses } from '@navio/nsdk';
import { apiUrl, responseEndpoint } from '../defineResource';

export const bookingRecoveryUrls = {
  postBookingRetryWheelPickup: responseEndpoint<BookingRetryWheelPickupApiData, BookingRetryWheelPickupApiResponses>({
    getUrl: ({ bookingId }) => apiUrl(`bookings/${bookingId}/retry-wheel-pickup/`),
    getBody: (data) => data
  })
};
